import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function customerReducer(state = initialState.customer , action) {
    if (action.type === types.READ_CUSTOMER_SUCCESS)
    {
        return action.customer;
    }
    else {
        return state;
    }
}
